import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'
import { API_GROUP_COUNT, API_GROUP_LIST } from 'utils/apiList'

const getGroupList = createAsyncThunk(
  'grouplist/list',
  async ({ search, page, size }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      let url = `${apiEndpoint}/${API_GROUP_LIST}`

      const queryParams = []

      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (size !== undefined) {
        queryParams.push(`size=${size}`)
      }
      if (search) {
        queryParams.push(`search=${encodeURIComponent(search)}`)
      }
      if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`
      }

      const { data } = await axios.get(url, config)
      return data.data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getGroupCount = createAsyncThunk(
  'grouplist/count',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.get(
        `${apiEndpoint}/${API_GROUP_COUNT}`,
        config,
      )
      return data.data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const setInventoryGroupLotId = createAsyncThunk(
  'inventory/setLotId',
  async ({ groupId, newLotCode }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const url = `${apiEndpoint}/api/v1/bussines/inventorygroups/lotid/${groupId}`

      const payload = { newLotCode }

      const { data } = await axios.post(url, payload, config)

      return data.data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const setInventorysLotId = createAsyncThunk(
  'inventoryRoot/setLotId',
  async ({ inventoryIds, newLotCode }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const url = `${apiEndpoint}/api/v1/bussines/inventory/lotid`

      const payload = { newLotCode, inventoryIds }

      const { data } = await axios.post(url, payload, config)

      return data.data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export {
  getGroupList,
  getGroupCount,
  setInventoryGroupLotId,
  setInventorysLotId,
}
